module.exports = __webpack_public_path__ + "media/images/lb/542-aa62f20d8c2306fc80a99d4f68914c5c.svg";